// Editor för DividerBlock — endast färgval.

import { Box, Stack, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DividerBlock } from '../types';

type Props = {
  block: DividerBlock;
  onChange: (patch: Partial<DividerBlock>) => void;
};

export const DividerBlockEditor = ({ block, onChange }: Props) => {
  const { t } = useTranslation('groupMessage');
  const color = block.color ?? '#dddddd';
  return (
    <Stack spacing={2}>
      <Stack direction='row' spacing={1} alignItems='center'>
        <Box
          component='input'
          type='color'
          value={color}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ color: e.target.value })}
          sx={{ width: 40, height: 40, border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 0, cursor: 'pointer' }}
        />
        <TextField
          label={t('builder.editors.lineColor') as string}
          value={color}
          onChange={(e) => onChange({ color: e.target.value })}
          size='small'
          sx={{ flex: 1 }}
        />
      </Stack>
    </Stack>
  );
};

export default DividerBlockEditor;
